import { Heart } from "lucide-react";
import KitCard from "@/components/KitCard";
import HorizontalScroll from "@/components/HorizontalScroll";
import type { KitWithPhoto } from "@/hooks/use-home-feed";

export default function TopKitsSection({ kits }: { kits: KitWithPhoto[] }) {
  if (kits.length === 0) return null;
  return (
    <section className="container py-12">
      <div className="mb-6 flex items-center gap-2">
        <Heart className="h-6 w-6 fill-red-500 text-red-500" />
        <h2 className="text-2xl font-black tracking-tight text-foreground md:text-3xl">Najpopularniejsze</h2>
      </div>
      <HorizontalScroll>
        {kits.map((kit) => (
          <div key={kit.id} className="min-w-0" style={{ scrollSnapAlign: "start" }}>
            <KitCard
              id={kit.id}
              club={kit.club}
              playerName={(kit as any).player_name}
              season={kit.season}
              brand={kit.brand}
              kitType={kit.kit_type}
              shirtVersion={(kit as any).shirt_version || undefined}
              size={(kit as any).size || undefined}
              condition={kit.condition || undefined}
              estimatedValue={kit.estimated_value || undefined}
              purchaseCurrency={kit.purchase_currency || undefined}
              photoUrl={kit.photoUrl}
              likesCount={kit.likesCount}
              isLikedByMe={kit.isLikedByMe}
              showPrice={false}
              forSale={(kit as any).for_sale === true}
            />
          </div>
        ))}
      </HorizontalScroll>
    </section>
  );
}